import { useState, useEffect } from "react";
import { Logo } from "@/components/Logo";

const links = [
  { href: "#how", label: "Wie es funktioniert" },
  { href: "#preview", label: "Vorgeschmack" },
  { href: "#example", label: "Beispiel" },
  { href: "#pricing", label: "Preis" },
];

export default function Nav({ onCta }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-cream/70 backdrop-blur-xl backdrop-saturate-150" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="inline-flex items-baseline">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="font-sans text-sm text-ink hover:text-charcoal transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-button"
            onClick={onCta}
            className="hidden sm:inline-flex font-display tracking-[0.22em] text-[11px] uppercase
                       bg-charcoal text-cream rounded-full px-6 py-3
                       hover:bg-umber transition-colors"
          >
            Entwurf erstellen
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-charcoal"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menü"
          >
            <span className="block w-6 h-px bg-charcoal mb-1.5" />
            <span className="block w-6 h-px bg-charcoal mb-1.5" />
            <span className="block w-4 h-px bg-charcoal" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-umber/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-serif text-lg text-charcoal"
            >
              {l.label}
            </a>
          ))}
          <button onClick={() => { setOpen(false); onCta(); }} className="btn-primary self-start">
            Entwurf erstellen
          </button>
        </div>
      )}
    </header>
  );
}
